import { createI18n } from 'vue-i18n'
import en from './locales/en'
import de from './locales/de'

const STORAGE_KEY = 'app-locale'

const savedLocale = localStorage.getItem(STORAGE_KEY)
const defaultLocale = savedLocale || 'de'

export const i18n = createI18n({
  legacy: false,
  locale: defaultLocale,
  fallbackLocale: 'en',
  messages: {
    en,
    de,
  },
  globalInjection: true,
})

export const setLocale = (locale: string) => {
  i18n.global.locale.value = locale as any
  localStorage.setItem(STORAGE_KEY, locale)
  document.documentElement.setAttribute('lang', locale)
}

export const availableLocales = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
]

export default i18n
